import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';

function TaskInput({ onCreateWithAI, onCancel, aiLoading, theme }) {
  const [title, setTitle] = useState('');

  const handleAIBreakdown = (e) => {
    if (e) e.preventDefault();
    if (title.trim() && !aiLoading) {
      onCreateWithAI(title.trim());
      setTitle('');
    }
  };

  return (
    <div data-testid="task-input-form">
      <form onSubmit={handleAIBreakdown}>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="What needs to be done?"
          autoFocus
          data-testid="task-title-input"
          className={`w-full border-b-2 ${theme?.colors.border || 'border-stone-200'} bg-transparent py-4 text-xl sm:text-2xl font-medium focus:border-[#E07A5F] focus:outline-none transition-colors`}
          style={{
            fontFamily: 'Manrope, sans-serif',
            color: theme?.colors.rawText || '#1c1917',
          }}
        />
      </form>

      <div className="flex items-center gap-3 mt-6">
        <button
          onClick={handleAIBreakdown}
          disabled={!title.trim() || aiLoading}
          data-testid="create-ai-breakdown-btn"
          className="flex-1 bg-[#E07A5F] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#D46B4E] transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2"
          style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
        >
          {aiLoading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              Breaking down...
            </>
          ) : (
            <>
              <Sparkles className="w-4 h-4" />
              AI Breakdown
            </>
          )}
        </button>

        <button
          onClick={onCancel}
          data-testid="cancel-task-btn"
          className={`p-2 rounded-md ${theme?.colors.textSecondary || 'text-stone-500'} hover:opacity-80 transition-colors`}
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <p className={`text-sm ${theme?.colors.textSecondary || 'text-stone-400'} mt-4`} style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
        Press <span className="font-medium text-[#E07A5F]">Enter</span> or click <span className="font-medium text-[#E07A5F]">AI Breakdown</span> to split your task into steps.
      </p>
    </div>
  );
}

export default TaskInput;